import $axios from "@/utils/request";
import { AxiosResponse, AxiosInstance } from "axios";

class SendSn {
  /**
   * @param ajax {AxiosInstance}
   */
  constructor(ajax = AxiosInstance) {
    this.$ajax = ajax;
  }
}

/**
 * @description post数据处理中心
 * @param url {string}
 * @param [data] {any}
 * @param [config] {AxiosResponse}
 * @returns {Promise<*>}
 */
SendSn.prototype.post = async function post(url, data, config = AxiosResponse) {
  const res = await this.$ajax.post(url, data, config);
  if (res.respCode === 0) {
    return res.obj;
  }
  throw res;
};

export default new SendSn($axios);
